import { redirectToStartPage } from '@/router';
import { useAuthStore } from '@/stores/auth';
import { validateJwtToken } from '@/utils/jwtToken';
import ForgotPassword from '@/views/auth/ForgotPassword.vue';
import Login from '@/views/auth/Login.vue';
import ResetPassword from '@/views/auth/ResetPassword.vue';
import VerifyEmail from '@/views/auth/VerifyEmail.vue';
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: async () => {
            const authStore = useAuthStore();
            if (authStore.isAuthenticated) {
                await redirectToStartPage(authStore.loggedInEmployee);
            }
        },
        meta: {
            pageTitle: 'Login'
        }
    },
    {
        path: '/inloggen',
        redirect: '/login'
    },
    {
        path: '/wachtwoord-vergeten',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
            pageTitle: 'Wachtwoord vergeten'
        }
    },
    {
        path: '/wachtwoord-reset/:employeeId/:token',
        name: 'reset-password',
        component: ResetPassword,
        beforeEnter: validateToken,
        meta: {
            pageTitle: 'Wachtwoord wijzigen'
        }
    },
    {
        path: '/email-verificatie/:token',
        name: 'verify-email',
        component: VerifyEmail,
        beforeEnter: validateToken,
        meta: {
            pageTitle: 'E-mailadres bevestigen'
        }
    }
];

async function validateToken(to: RouteLocationNormalized) {
    const { token: jwtTokenFromParams } = to.params as { token: string };
    const token = await validateJwtToken(jwtTokenFromParams);

    if (!token) return { name: 'login' };
}

export default routes;
